import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, Loader2Icon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
// import emailjs from '@emailjs/browser'; // Assuming this is installed in the project
export function ContactForm() {
  const formRef = useRef<HTMLFormElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      // NOTE: User needs to replace these with their actual EmailJS credentials
      // await emailjs.sendForm(
      //   'YOUR_SERVICE_ID',
      //   'YOUR_TEMPLATE_ID',
      //   formRef.current!,
      //   'YOUR_PUBLIC_KEY'
      // );
      // Simulating API call for now
      await new Promise(resolve => setTimeout(resolve, 1500));
      setSubmitStatus('success');
      if (formRef.current) formRef.current.reset();
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contact-form" className="py-24 bg-brand-black relative border-t border-white/5" data-id="element-13">
      {/* Background glow */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-green/5 blur-[150px] rounded-full pointer-events-none" data-id="element-14" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-15">
        <div className="max-w-3xl mx-auto" data-id="element-16">
          <div className="text-center mb-12" data-id="element-17">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-brand-yellow mb-4" data-id="element-18">
              SOLICITA TU DIAGNÓSTICO GRATUITO
            </h2>
            <p className="text-lg text-brand-gray" data-id="element-19">
              Completa el formulario y un especialista te contactará en menos de
              24 horas.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-dark border border-white/10 rounded-2xl p-8 md:p-10 shadow-[0_0_30px_rgba(16,185,129,0.05)] relative overflow-hidden" data-id="element-20">
            {/* Top green accent line */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-green/20 via-brand-green to-brand-green/20" data-id="element-21" />

            {submitStatus === 'success' ? <div className="flex flex-col items-center justify-center py-16 text-center" data-id="element-22">
                <CheckCircleIcon className="w-16 h-16 text-brand-green mb-6" data-id="element-23" />
                <h3 className="font-heading text-3xl font-bold text-white mb-4" data-id="element-24">
                  ¡Solicitud Enviada!
                </h3>
                <p className="text-brand-gray text-lg" data-id="element-25">
                  Te contactaremos en menos de 24 horas para tu diagnóstico
                  gratuito.
                </p>
                <button onClick={() => setSubmitStatus('idle')} className="mt-8 text-brand-yellow hover:text-white underline underline-offset-4 transition-colors" data-id="element-26">
                  Enviar otra solicitud
                </button>
              </div> : <form ref={formRef} onSubmit={handleSubmit} className="space-y-6" data-id="element-27">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-28">
                  {/* Nombre */}
                  <div className="space-y-2" data-id="element-29">
                    <label htmlFor="user_name" className="text-sm font-medium text-brand-gray" data-id="element-30">
                      Nombre Completo *
                    </label>
                    <input type="text" id="user_name" name="user_name" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all" placeholder="Juan Pérez" data-id="element-31" />
                  </div>

                  {/* Email */}
                  <div className="space-y-2" data-id="element-32">
                    <label htmlFor="user_email" className="text-sm font-medium text-brand-gray" data-id="element-33">
                      Email *
                    </label>
                    <input type="email" id="user_email" name="user_email" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all" placeholder="juan@empresa.com" data-id="element-34" />
                  </div>

                  {/* Teléfono */}
                  <div className="space-y-2" data-id="element-35">
                    <label htmlFor="user_phone" className="text-sm font-medium text-brand-gray" data-id="element-36">
                      Teléfono *
                    </label>
                    <input type="tel" id="user_phone" name="user_phone" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all" placeholder="(555) 123-4567" data-id="element-37" />
                  </div>

                  {/* Empresa */}
                  <div className="space-y-2" data-id="element-38">
                    <label htmlFor="company_name" className="text-sm font-medium text-brand-gray" data-id="element-39">
                      Nombre de la Compañía *
                    </label>
                    <input type="text" id="company_name" name="company_name" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all" placeholder="Pest Control LLC" data-id="element-40" />
                  </div>

                  {/* Instagram */}
                  <div className="space-y-2" data-id="element-41">
                    <label htmlFor="company_ig" className="text-sm font-medium text-brand-gray" data-id="element-42">
                      Instagram de la Compañía
                    </label>
                    <input type="text" id="company_ig" name="company_ig" className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all" placeholder="@tuempresa" data-id="element-43" />
                  </div>

                  {/* Website */}
                  <div className="space-y-2" data-id="element-44">
                    <label htmlFor="company_website" className="text-sm font-medium text-brand-gray" data-id="element-45">
                      Website (Opcional)
                    </label>
                    <input type="url" id="company_website" name="company_website" className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all" placeholder="www.tuempresa.com" data-id="element-46" />
                  </div>
                </div>

                {/* Selects */}
                <div className="space-y-6 pt-4 border-t border-white/5" data-id="element-47">
                  <div className="space-y-2" data-id="element-48">
                    <label htmlFor="current_clients" className="text-sm font-medium text-brand-gray" data-id="element-49">
                      ¿Cuántos clientes atiendes por semana? *
                    </label>
                    <select id="current_clients" name="current_clients" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all appearance-none" data-id="element-50">
                      <option value="" disabled selected data-id="element-51">
                        Selecciona una opción
                      </option>
                      <option value="1-5" data-id="element-52">1-5 clientes</option>
                      <option value="6-10" data-id="element-53">6-10 clientes</option>
                      <option value="11-20" data-id="element-54">11-20 clientes</option>
                      <option value="20+" data-id="element-55">Más de 20 clientes</option>
                    </select>
                  </div>

                  <div className="space-y-2" data-id="element-56">
                    <label htmlFor="goal_clients" className="text-sm font-medium text-brand-gray" data-id="element-57">
                      ¿Cuál es tu meta semanal de clientes nuevos? *
                    </label>
                    <select id="goal_clients" name="goal_clients" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all appearance-none" data-id="element-58">
                      <option value="" disabled selected data-id="element-59">
                        Selecciona una opción
                      </option>
                      <option value="5-10" data-id="element-60">5-10 clientes nuevos</option>
                      <option value="11-20" data-id="element-61">11-20 clientes nuevos</option>
                      <option value="21-50" data-id="element-62">21-50 clientes nuevos</option>
                      <option value="50+" data-id="element-63">Más de 50 clientes nuevos</option>
                    </select>
                  </div>

                  <div className="space-y-2" data-id="element-64">
                    <label htmlFor="ads_experience" className="text-sm font-medium text-brand-gray" data-id="element-65">
                      ¿Has hecho publicidad digital antes? *
                    </label>
                    <select id="ads_experience" name="ads_experience" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all appearance-none" data-id="element-66">
                      <option value="" disabled selected data-id="element-67">
                        Selecciona una opción
                      </option>
                      <option value="Si" data-id="element-68">Sí, con buenos resultados</option>
                      <option value="Un poco" data-id="element-69">
                        Un poco pero sin resultados
                      </option>
                      <option value="No" data-id="element-70">No, nunca</option>
                    </select>
                  </div>

                  <div className="space-y-2" data-id="element-71">
                    <label htmlFor="ads_budget" className="text-sm font-medium text-brand-gray" data-id="element-72">
                      ¿Cuánto has invertido en publicidad? *
                    </label>
                    <select id="ads_budget" name="ads_budget" required className="w-full bg-brand-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-yellow focus:ring-1 focus:ring-brand-yellow transition-all appearance-none" data-id="element-73">
                      <option value="" disabled selected data-id="element-74">
                        Selecciona una opción
                      </option>
                      <option value="Nada" data-id="element-75">Nada</option>
                      <option value="<500" data-id="element-76">Menos de $500</option>
                      <option value="500-2000" data-id="element-77">$500 - $2,000</option>
                      <option value="2000-5000" data-id="element-78">$2,000 - $5,000</option>
                      <option value=">5000" data-id="element-79">Más de $5,000</option>
                    </select>
                  </div>
                </div>

                {submitStatus === 'error' && <div className="flex items-center space-x-2 text-red-400 bg-red-400/10 p-4 rounded-lg" data-id="element-80">
                    <AlertCircleIcon className="w-5 h-5 flex-shrink-0" data-id="element-81" />
                    <p className="text-sm" data-id="element-82">
                      Hubo un error al enviar tu solicitud. Por favor, intenta
                      de nuevo o agenda directamente en el calendario abajo.
                    </p>
                  </div>}

                <div className="pt-6" data-id="element-83">
                  <button type="submit" disabled={isSubmitting} className="w-full bg-brand-yellow hover:bg-brand-yellow/90 disabled:bg-brand-yellow/50 disabled:cursor-not-allowed text-brand-black font-heading font-bold text-xl py-5 rounded-lg uppercase tracking-wider transition-all shadow-[0_0_20px_rgba(212,168,67,0.2)] hover:shadow-[0_0_30px_rgba(212,168,67,0.4)] flex items-center justify-center" data-id="element-84">
                    {isSubmitting ? <>
                        <Loader2Icon className="w-6 h-6 mr-2 animate-spin" data-id="element-85" />
                        Enviando...
                      </> : 'Enviar Mi Solicitud'}
                  </button>
                </div>

                <div className="text-center pt-4" data-id="element-86">
                  <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-brand-gray hover:text-white transition-colors group" data-id="element-87">
                    <CalendarIcon className="w-4 h-4 mr-2 text-brand-yellow group-hover:scale-110 transition-transform" data-id="element-88" />
                    <span className="underline decoration-brand-gray/50 underline-offset-4 group-hover:decoration-brand-yellow/50" data-id="element-89">
                      O agenda tu cita directamente →
                    </span>
                  </a>
                </div>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}